// extracted by mini-css-extract-plugin
export default {"header":"Header_header__3KioO","headerContainer":"Header_headerContainer__WaxW-","header__menu":"Header_header__menu__NcSP+","header__logo":"Header_header__logo__2gpXC"};